module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/course-4-photo-1-2d64cd6aed9d898fbd57a6d937ff4fea.webp";